import React, {useState, useRef, useEffect} from "react";
import * as t from "./types";
import "./EventPage.css";
import * as Api from "./Api";
import {Loading} from "./Loading";
import {useParams} from "react-router-dom";
import {getAppointmentId} from "./types";
import logo from "./logo.png";

// const LOG = console.log;
// const WARN = console.warn;
// const ERR = console.error;

// outgoing data

// incoming data

// components
interface HeadingProps {
  event: t.IEvent;
}
const Heading = (props: HeadingProps) => {
  // LOG("Heading");
  const {event} = props;
  return (
    <div className="heading">
      <div className="heading-content">
        <a href="http://kms-taekwondo.at" className="logo-link" >
          <img className="logo" src={logo}></img>
        </a>
        <Title text={event.title} />
        <Subtitle text={event.subtitle} />
      </div>
      <Description event={event} />
    </div>
  );
};
interface TitleProps {
  text: string;
}
const Title = (props: TitleProps) => {
  // LOG("Title");
  const {text} = props;
  return <div className="page-title">{text}</div>;
};

interface SubtitleProps {
  text: string;
}
const Subtitle = (props: SubtitleProps) => {
  // LOG("Subtitle");
  const {text} = props;
  return <div className="page-subtitle">{text}</div>;
};

interface DescriptionProps {
  event: t.IEvent;
}
const Description = (props: DescriptionProps) => {
  // LOG("Description");
  const {event} = props;
  return (
    <div className="description">
      <p>{event.description}</p>

      <a href="http://kms-taekwondo.at" className="homepage-link">Zur Homepage</a>
    </div>
  );
};

interface RegistrationInputProps {
  show: boolean;
  tryRegister: (data: t.IEventRegistrationData) => void;
  cancel: () => void;
  eventAppointment: t.IEventAppointment;
  eventid: number;
}
const RegistrationInput = (props: RegistrationInputProps) => {
  // LOG("RegistrationInput");
  const nameRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);
  const ageRef = useRef<HTMLInputElement>(null);
  const [canSubmit, setCanSubmit] = useState<Boolean>(false);
  const {eventAppointment, tryRegister, cancel, show, eventid} = props;
  if (!show) {
    return <div />;
  }
  const notEmpty = (i: React.RefObject<HTMLInputElement>) => {
    return i.current !== null && i.current.value !== "";
  }
  const validate = () => {
    const canNowSubmit = notEmpty(nameRef) && notEmpty(emailRef) && notEmpty(phoneRef) && notEmpty(ageRef) && parseInt(ageRef.current!.value) > 0;
    if (canSubmit !== canNowSubmit) {
      setCanSubmit(canNowSubmit);
    }
  }
  const confirm = () => {
    const reg: t.IEventRegistrationData = {
      eventid: eventid,
      name: nameRef.current?.value ?? "",
      phone: phoneRef.current?.value ?? "",
      email: emailRef.current?.value ?? "",
      age: parseInt(ageRef.current?.value ?? '0'),
      eventAppointmentId: eventAppointment.id,
    };
    tryRegister(reg);
  };
  return (
    <div className="registration-input">
      <input ref={nameRef} placeholder="Name" onChange={validate} />
      <input type="number" ref={ageRef} placeholder="Alter" onChange={validate} min="1" />
      <input ref={emailRef} placeholder="Email" onChange={validate} />
      <input ref={phoneRef} placeholder="Telefon" onChange={validate} />
      <div className="buttons-row">
        <button onClick={confirm} disabled={!canSubmit}>Bestätigen</button>
        <button onClick={cancel}>Abbrechen</button>
      </div>
    </div>
  );
};

interface EventAppointmentProps {
  eventAppointment: t.IEventAppointment | t.INoAppointment;
  eventid: number;
  updateData: (data: t.IIncomoingEventInfo) => void;
}
const EventAppointment = (props: EventAppointmentProps) => {
  // LOG("EventAppointment");
  const [isShowingPopup, setIsShowingPopup] = useState(false);
  const [registrationResult, setRegistrationResult] = useState<boolean | null>(
    null
  );
  const {eventAppointment, eventid, updateData} = props;
  if (!eventAppointment.hasAppointment) {
    // LOG("no appointment...");
    return <div />;
  }
  // registration stuff here!
  const tryRegister = (data: t.IEventRegistrationData) => {
    Api.registerForEvent(data).then((res) => {
      setIsShowingPopup(false);
      if (res.status === "error") {
        setRegistrationResult(false);
      } else {
        setRegistrationResult(true);
        updateData(res);
      }
      return res;
    });
  };
  const cancel = () => {
    setIsShowingPopup(false);
  };

  const registerButton = (
    <button onClick={() => setIsShowingPopup(true)}>Anmeldung</button>
  );

  const available = Math.max(
    0,
    eventAppointment.maximumRegistrations -
    (eventAppointment.currentRegistrations || 0)
  );

  const emptyDiv = <div />;
  const button = isShowingPopup || available <= 0 ? emptyDiv : registerButton;

  const statusMessage = () => {
    if (registrationResult === null) {
      return <div />;
    }
    if (registrationResult) {
      return <p className="registration-success">Anmeldung erfolgreich</p>;
    }
    return <p className="registration-fail">Anmeldung fehlgeschlagen</p>;
  };

  const availableMessage =
    available > 0 ? (
      <p className="count-available">Freie Plätze: {available}</p>
    ) : (
        <p className="count-not-available">Freie Plätze: {available}</p>
      );

  return (
    <div className="event-appointment">
      <p className="appointment-text">Termin: {eventAppointment.text} Uhr</p>
      {availableMessage}
      <p>Gesamt Plätze: {eventAppointment.maximumRegistrations}</p>
      {button}
      {statusMessage()}
      <RegistrationInput
        show={isShowingPopup}
        tryRegister={tryRegister}
        cancel={cancel}
        eventAppointment={eventAppointment}
        eventid={eventid}
      />
    </div>
  );
};

interface TableHeaderProps {
  table: t.IEventTable;
}
const TableHeader = (props: TableHeaderProps) => {
  // LOG("TableHeader");
  return <div></div>;
};

const cmp3 = (key: string) => (a: any, b: any) => {
  if (a[key] < b[key]) return -1;
  if (a[key] === b[key]) return 0;
  return 1;
};

interface EventTableProps {
  table: t.IEventTable;
  rows: {[tableId: string]: t.IEventRow[]};
  columns: {[tableId: string]: t.IEventColumn[]};
  appointments: {[tableRowColId: string]: t.IEventAppointment};
  updateData: (data: t.IIncomoingEventInfo) => void;
}
const EventTable = (props: EventTableProps) => {
  // LOG("EventTable");
  const {table, rows, columns, appointments, updateData} = props;
  const tableStyle = {
    backgroundColor: table.backgroundColor,
    color: table.foregroundColor,
  };

  const tableRows = rows[table.id.toString()].sort(cmp3("rowIndex"));
  const tableColumns = columns[table.id.toString()].sort(cmp3("columnIndex"));
  const getCells = (rowId: number) => {
    const cells: (t.IEventAppointment | null)[] = tableColumns.map((col) => {
      return appointments[getAppointmentId(table.id, rowId, col.id)];
    });
    return cells;
  };

  const emptyHeader = <th />;
  const columnStyle = (col: t.IEventColumn) => {
    return {
      color: col.textColor,
      "background-color": col.backgroundColor,
    };
  };
  const rowStyle = (row: t.IEventRow) => {
    return {
      color: row.textColor,
      "background-color": row.backgroundColor,
    };
  };

  return (
    <div>
      <div>
        <TableHeader table={table} />
      </div>
      <table style={tableStyle}>
        <thead>
          {emptyHeader}
          {tableColumns.map((col) => (
            <th>
              <div className="column-header" style={columnStyle(col)}>
                {col.columnHeader}
              </div>
            </th>
          ))}
        </thead>
        {tableRows.map((row) => (
          <tr style={rowStyle(row)}>
            <td className="row-header">{row.rowHeader}</td>
            {getCells(row.id).map((cell) => {
              if (cell) {
                return (
                  <td>
                    <EventAppointment
                      eventAppointment={cell}
                      eventid={table.eventid}
                      updateData={updateData}
                    />
                  </td>
                );
              }
              return <td />;
            })}
          </tr>
        ))}
      </table>
    </div>
  );
};

interface EventTableContainerProps {
  tables: t.IEventTable[];
  rows: {[tableId: string]: t.IEventRow[]};
  columns: {[tableId: string]: t.IEventColumn[]};
  appointments: {[tableRowColId: string]: t.IEventAppointment};
  updateData: (data: t.IIncomoingEventInfo) => void;
}
const EventTableContainer = (props: EventTableContainerProps) => {
  // LOG("EventTableContainer");
  const {tables, rows, columns, appointments, updateData} = props;
  return (
    <div>
      {tables.map((table) => (
        <EventTable
          table={table}
          rows={rows}
          columns={columns}
          appointments={appointments}
          updateData={updateData}
        />
      ))}
    </div>
  );
};

const handleIncomingEventInfo = (incoming: t.IIncomoingEventInfo) => {
  const registrationsMap: {[appointmentId: number]: number} = {};
  for (let appointment of incoming.appointments) {
    appointment.currentRegistrations = incoming.registrations.filter(
      (r) => r.eventAppointmentId === appointment.id
    ).length;
    registrationsMap[appointment.id] = appointment.currentRegistrations;
    // LOG("appt current regs", appointment.currentRegistrations);
  }
  // LOG("registrations map", registrationsMap);

  const rowsMap: {[tableId: string]: t.IEventRow[]} = {};
  for (let table of incoming.tables) {
    rowsMap[table.id] = incoming.rows.filter(
      (r) => r.eventRegistrationTableId === table.id
    );
  }

  const colsMap: {[tableId: string]: t.IEventColumn[]} = {};
  for (let table of incoming.tables) {
    colsMap[table.id] = incoming.columns.filter(
      (c) => c.eventRegistrationTableId === table.id
    );
  }

  const appointmentsMap: {
    [tableRowColId: string]: t.IEventAppointment;
  } = {};
  for (let appointment of incoming.appointments) {
    appointment.currentRegistrations = registrationsMap[appointment.id];
    appointment.hasAppointment = true;
    appointmentsMap[
      getAppointmentId(
        appointment.tableid,
        appointment.rowid,
        appointment.colid
      )
    ] = appointment;
  }

  const info: t.IEventInfo = {
    event: incoming.event,
    tables: incoming.tables,
    rows: rowsMap,
    columns: colsMap,
    appointments: appointmentsMap,
  };

  return info;
};

interface EventPageProps {}
export const EventPage = (props: EventPageProps) => {
  // LOG("const");
  const [eventInfo, setEventInfo] = useState<t.IEventInfo | null>(null);

  const {id} = useParams();

  const updateData = (incoming: t.IIncomoingEventInfo) => {
    setEventInfo(handleIncomingEventInfo(incoming));
  };

  useEffect(() => {
    if (eventInfo !== null) {
      return;
    }
    Api.getEventInfo(id).then((response: t.IIncomoingEventInfo) => {
      console.log("response received");
      const info = handleIncomingEventInfo(response);
      setEventInfo(info);
    });
  });

  console.log("event info null?", eventInfo === null);

  if (eventInfo === null) {
    console.log("loading");
    return <Loading />;
  }

  console.log("finished loading");

  const {event, tables, rows, columns, appointments} = eventInfo;

  return (
    <div className="event-registration-page">
      <Heading event={event} />
      <EventTableContainer
        tables={tables}
        rows={rows}
        columns={columns}
        appointments={appointments}
        updateData={updateData}
      />
    </div>
  );
};
